import TagContainer from '@enums/tagContainer';
import { useAnalytics } from '@context/analytics.context';
import { BucketTestBNPLEvent } from '@interfaces/models/internal/analytics-event/cart-event';

const useBucketTestEvents = (action: BucketTestBNPLEvent['action']) => {
  const { sendEvent, updateDataLayer } = useAnalytics();
  const eventBaseObject = {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      action,
    },
  };
  const sendBNPLShowEvent = (label: BucketTestBNPLEvent['label']) => {
    updateDataLayer({
      abtestBNPL: `${action}-${label}`,
    });
    sendEvent({
      ...eventBaseObject,
      payload: {
        ...eventBaseObject.payload,
        event: 'abtestBNPL_modal_shown',
        label,
      },
    });
  };
  const sendBNPLClickEvent = (label: BucketTestBNPLEvent['label']) => {
    sendEvent({
      ...eventBaseObject,
      payload: {
        ...eventBaseObject.payload,
        event: 'abstestBNPL_modal_click',
        label,
      },
    });
  };
  return { sendBNPLShowEvent, sendBNPLClickEvent };
};

export default {};
export { useBucketTestEvents };
